<template>
    <section id="print">
        <div class="rowVar">
            <ul>
                <template v-for="(variety, index) in varieties">
                    <li v-for="q in +variety.agencyQuantity" class="variety varietyRow">
                        <div class="varietyContainer">
                            <div class="barcodeContainer">
                                <textarea  
                                    rows="1"  
                                    type="text"  
                                    v-model="variety.product_title"  
                                    class="varietyPrice"  
                                    @input="adjustHeight"  
                                ></textarea> 
                                <div class="row" v-if="variety.attributes && variety.attributes.length">
                                    <div v-for="item in variety.attributes" class="itemRow" :key="item.id">
                                        <span class="varName" v-if="variety.color && variety.color.name">
                                            {{ item.pivot.value + ' | ' + variety.color.name}}
                                        </span>
                                        <span class="varName" v-else>
                                            {{ item.pivot.value}}
                                        </span>
                                    </div>
                                </div>
                                <div class="row" v-else>
                                   <div class="itemRow">
                                       <span class="varName">
                                           {{ extractColor(variety.variety_title) }}
                                        </span>
                                    </div>
                                </div>
                                
                                <!-- <div class="itemRow">
                                    <b>{{ checkLabel(item.key) }}</b>
                                    <span class="varName">
                                        {{ variety.title }}
                                    </span>
                                </div> -->

                                  <barcode
                                        class="varietyBarcode"
                                        fontSize="40"
                                        width="7"
                                        marginBottom="0"
                                        marginTop="0"
                                        elementTag="img"
                                        :displayValue="true"
                                        height="50"
                                       :value="variety.variety_barcode"
                                    >
                                    </barcode>

                                <span class="priceName" v-if="variety.unit_price > variety.price">
                                    <del>{{ formatPrice(variety.unit_price) }} تومان</del>
                                </span>
                                <span class="priceName">
                                    {{ formatPrice(variety.price) }} تومان  
                                </span>
                            </div>
                        </div>
                    </li>
                </template>
            </ul>
        </div>
        <button id="printBtn" @click="print">پرینت</button>
    </section>
</template>

<script>
import printVarietiesImpl from "@@/core/pages/Havale/HavaleBarcodeLmpl";
export default {
    extends: printVarietiesImpl,
};
</script>

<style src="@@/core/pages/printVarieties/printVarietiesStyle.css"></style>
